<div class="form-style">
  <h3>
    {{ 'edit_room.labels.titleAddNewModal' | translate }}
  </h3>
  <div class="formly-container">
    <formly-form [form]="form" [fields]="formFields" [model]="formModel">
    </formly-form>
  </div>
  <div class="button-container">
    <su-button
      type="button"
      [skin]="'secondary'"
      (click)="closeDialog()"
      [label]="'buildingMaintenance.labels.buttonCancel' | translate">
    </su-button>
    <su-button
      type="submit"
      [skin]="'primary'"
      [disabled]="isSaveDisabled()"
      (click)="onSubmit()"
      [label]="'buildingMaintenance.labels.buttonSave' | translate">
    </su-button>
  </div>
</div>

<app-spinner-overlay [show]="isLoading"></app-spinner-overlay>
